<template>
	<form :action="$route.path" v-if="formfields.length > 0" class="FieldForm" v-on:submit.prevent="">
		<div
		ref="fieldset"

		v-for="field in formfields"
		v-if="field.fields.length > 0"

		:is="'f-' + field.type"
		:key="field.name"
		:field="field"></div>

		<div v-if="usernotice" class="st-form__fieldset">
		    <div class="st-notice">
		        <div class="row">
		            <div class="col-xs-12 col-sm-1">
		                <i class="fa fa-hand-o-right" aria-hidden="true"></i>
		            </div>
		            <div class="col-xs-12 col-sm-11">
		                <div class="user-content-wrapper">
		                    {{ $t("After submitting this form, an automatic e-mail will be sent with login information to the specified address.") }}
		                </div>
		            </div>
		        </div>
		    </div>
		</div>

		<div class="st-form__fieldset">
			<div class="row">
				<div class="col-xs-12 col-sm-6">
					<button type="button" v-if="cancelable" @click="$emit('cancel')" :title="$t('Cancel')" class="no-btn inline-nav">{{ $t('Cancel') }}</button>
				</div>
				<div class="col-xs-12 col-sm-6 text-sm-right">
					<router-link type="button" v-if="!isnew && formtype == 'präsentation'" :to="{ name: 'editor' }" class="inline-block st-btn">{{ $t('to the editor') }}</router-link>
					<button @click="create" v-if="isnew" type="button" class="st-btn st-btn--submit" :class="{'st-btn--loading':saveing}" :disabled="saveing">{{ $t('Create') }}</button>
					<button @click="save" v-else type="button" class="st-btn st-btn--submit":class="{'st-btn--loading':saveing}" :disabled="saveing">{{ $t('Save') }}</button>
				</div>
			</div>
		</div>
	</form>
</template>

<script>

import FFieldset from '@/components/form/f-fieldset';

export default {
	name: 'FieldForm',
	components: {
		FFieldset
	},
	computed: {
		saveing(){
			return this.$store.getters.saveing;
		},
	},
	props: {
		formtype: {
			default: 'user'
		},
		formfields: {
			type: Array,
			default(){
				return [];
			}
		},
		cancelable: {
			type: Boolean,
			default: false
		},
		usernotice: {
			type: Boolean,
			default: false
		},
		isnew: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		getSaveableFields(fields){
			const self = this;
			let out = {};
			fields.forEach(item => {
				if(item.type == "files") return; //weiter
				if(item.type == "image") return; //weiter
				if(item.type == "user-slides") return; //weiter

				if(typeof item.value !== 'undefined'){
					out[item.name] = item.value;
				}

				if(item.fields){
					out = Object.assign({}, out, self.getSaveableFields(item.fields));
				}
			});
			return out;
		},
		getAndValid(){
			const self = this;
			return new Promise((resolve, reject) => {

				let promises = []
				for (let child in self.$refs.fieldset) {
		        	promises.push(self.$refs.fieldset[child].validate());
		      	}

		      	Promise.all(promises)
				.then((result) => {
					let payload = self.getSaveableFields(self.formfields);
					resolve(payload);
				})
				.catch(errors => {
					reject(errors)
				});
			});
		},
		create(ev){
			const self = this;
			ev.preventDefault();

			this.getAndValid()
			.then(payload => {
				self.$emit('create', payload);
			})
			.catch(errors => {
				console.error(errors);
				self.$store.commit('ADD_NOTICE', {
					'text': 'There are errors in the Form',
					'type': 'error'
				});
			});
		},
		save(ev){
			const self = this;
			ev.preventDefault();

			this.getAndValid()
			.then(payload => {
				self.$emit('save', payload);
			})
			.catch(errors => {
				console.error(errors);
				self.$store.commit('ADD_NOTICE', {
					'text': 'There are errors in the Form',
					'type': 'error'
				});
			});
		},
		cancel(ev){
			this.$emit('cancel');
		}
	}
}
</script>

<style scoped>
.error{
	color: #a3248f;
}
</style>



// WEBPACK FOOTER //
// src/components/form/FieldForm.vue